(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User($resource) {
        return $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'list': {
                url: 'api/users/list',
                method: 'GET',
                isArray: true
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},

            // call the deleteUserRequest in UserResource with method post
            'deleteRequest': {
                url: 'api/users/deleteUserRequest',
                method: 'post'},
            'queryByDomain': {
                url: 'api/domain/:id/users',
                method: 'GET',
                isArray: true
            },
            'impersonate': {
                url: 'api/usersImpersonate',
                method: 'POST'
            },
            'restore': {
                url: 'api/restoreUsersImpersonate',
                method: 'GET'
            },
            'create': {
                url: 'api/createUser',
                method: 'POST'
            },
            'createOTP': {
                url: 'api/createOtp',
                method: 'GET'
            },
            'checkCode': {
                url: 'api/checkOtp',
                method: 'GET'
            },
            'sendHelpMail': {
                url: 'api/sendHelpMail',
                method: 'POST'
            },
            'sendPrivacyMail': {
                url: 'api/sendPrivacyMail',
                method: 'POST'
            },
            'checkTerms' : {
                url: 'api/checkTermsConditions',
                method: 'GET'
            },
            'setTerms' : {
                url: 'api/setTermsConditions',
                method: 'POST'
            },
            'getTerms' : {
                url: 'api/getTermsConditions',
                method: 'GET'
            },
            'updateNotifications': {
                url: 'api/updateNotifications',
                method: 'PUT'
            },
            'getTOTP': {
                url: 'api/getTOTP',
                method: 'GET'
            },
            'set2FEmail': {
                url: 'api/set2FEmail',
                method: 'GET'
            },
            'getLoggedUserEmail': {
                url: 'api/getLoggedUserEmail',
                method: 'GET'
            },
            'checkReportCommandsEmail': {
                url: 'api/checkReportCommandsEmail',
                method: 'GET'
            }
        });
    }
})();
